const apiConfig = {
  auth: process.env.BASE_URL_AUTH,
  project: process.env.BASE_URL_PROJECT,
  upload: process.env.BASE_URL_UPLOAD,
  assets: process.env.BASE_ASSETS_PATH,
};

export default apiConfig;
